import React from 'react';
import { MapPin, Phone, Mail,Clock } from 'lucide-react';
import SectionHeader from '../components/SectionHeader';

const ContactPage: React.FC = () => {
  return (
    <div className="pt-20 bg-primary-black min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <SectionHeader
          eyebrow="GET IN TOUCH"
          title="Contact Us"
          subtitle="We'd love to hear from you. Reach out for reservations, inquiries, or just to say hello."
          darkMode={true}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Location */}
          <div className="bg-primary-black border border-primary-gold rounded-lg p-8 text-center">
            <MapPin className="w-12 h-12 mx-auto mb-4 text-primary-gold" />
            <h3 className="text-xl font-bold text-primary-gold mb-4 font-display">Location</h3>
            <p className="text-gray-300">Bainsford Main Street</p>
            <p className="text-gray-300">Falkirk</p>
            <p className="text-gray-300 mt-2">FK2 7NU</p>
          </div>


           <div className="bg-primary-black border border-primary-gold rounded-lg p-8 text-center">
              <Clock className="w-12 h-12 mx-auto mb-4 text-primary-gold" />
              <h3 className="text-xl font-bold text-primary-gold mb-4 font-display">Opening Hours</h3>
              <div className="text-left max-w-xs mx-auto">

      
                <p className="text-gray-300 mb-2">Mon-Sun: 11am - 11pm</p>
                <p className="text-white font-semibold mb-2">Restaurant:</p>
                <p className="text-gray-300 mb-1">Sun-Fri: 12pm - 7pm</p>
                <p className="text-gray-300 mb-4">Sat: 12pm - 7:30pm</p>
                
              </div>
            </div>

          {/* Phone */}
          <div className="bg-primary-black border border-primary-gold rounded-lg p-8 text-center">
            <Phone className="w-12 h-12 mx-auto mb-4 text-primary-gold" />
            <h3 className="text-xl font-bold text-primary-gold mb-4 font-display">Phone</h3>
            <p className="text-gray-300">(01324) 636330</p>
            
          </div>

          {/* Email */}
          <div className="bg-primary-black border border-primary-gold rounded-lg p-8 text-center">
            <Mail className="w-12 h-12 mx-auto mb-4 text-primary-gold" />
            <h3 className="text-xl font-bold text-primary-gold mb-4 font-display">Email</h3>
            <p className="text-gray-300">enquiries@thecreamerysportsbar.com</p>
          </div>

        </div>
      </div>

      {/* Reservation CTA Section */}
      <section className="relative py-20 bg-primary-black overflow-hidden">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-gold opacity-5 rounded-full blur-3xl"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-gold mb-6 font-display">
            Make a Reservation
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            Ready to visit? Call us to book your table or reserve a snooker/pool table
          </p>
          <a 
            href="/book" 
            className="inline-block bg-primary-gold text-primary-black px-12 py-4 rounded-full font-semibold text-lg hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
            aria-label="Go to reservation page to book a table"
          >
            Make a Reservation
          </a>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
